import { connect } from 'react-redux';
import { CommentableTypes } from '../../../Comment/redux/types';
import { getDeviationById } from '../../../redux/deviations/selectors';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
var mapStateToProps = function (state, _a) {
    var _b;
    var commentableItemId = _a.commentableItemId, commentableType = _a.commentableType;
    if (commentableType === CommentableTypes.COMMENT_DEVIATION) {
        var deviation = getDeviationById(state, commentableItemId);
        if (deviation) {
            var authorName = (_b = deviation === null || deviation === void 0 ? void 0 : deviation.author) === null || _b === void 0 ? void 0 : _b.username;
            var _c = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), folderId = _c.folderId, isPremium = _c.isPremium, isPaidFolder = _c.isPaidFolder, subproductId = _c.subproductId;
            if (!isPremium || !deviation.hasPrivateComments) {
                return { commentsDisabledForAllUsers: true };
            }
            return {
                commentsDisabledForAllUsers: false,
                folderId: folderId,
                subproductId: subproductId,
                isPaidFolder: isPaidFolder,
                authorName: authorName,
                user: getCurrentUser(state),
            };
        }
    }
    return { commentsDisabledForAllUsers: true };
};
export default connect(mapStateToProps);
//# sourceMappingURL=DisabledOrPrivateInfo.container.js.map